<template>
  <div id="app">
    <div class="container">
      <div class="card">
        <div class="logo">
          <img src="@/assets/images/logo-small.svg" />
        </div>
        <h1>{{ title }}</h1>
        <h2>{{ subTitle }}</h2>
        <p>{{ description }}</p>
        <slot />
      </div>
      <div class="logoname">
        <img src="@/assets/images/name.svg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: String,
    subTitle: String,
    description: String,
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  width: 100%;
  height: 100%;
  padding-left: 20%;
  overflow: hidden;

  &::before,
  &::after {
    position: absolute;
    width: 1000px;
    height: 1000px;
    content: url('../assets/images/logo.svg');
  }
  &::before {
    top: -600px;
    right: -500px;
  }
  &::after {
    bottom: -550px;
    left: -650px;
  }
}
.logo {
  padding-bottom: 48px;
}
.card {
  z-index: 1;
  width: 500px;
  height: 350px;
  padding: 50px;
  margin: auto 0;
  background-color: #fff;
  border-radius: 16px;
  // TODO: Check contrast
  /* border: 1px solid $white-grey; */
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  h1 {
    margin-bottom: 17px;
  }
  h2 {
    font-size: 20px;
    margin-bottom: 24px;
  }
  p{
    font-size: 16px;
  }
}

.logoname {
  position: absolute;
  right: 5%;
  bottom: 5%;
}
</style>
